export interface FinancialWrapper {
  active: boolean;
  country: string;
  description: string;
  id: string;
  incurringCGT: boolean;
  name: string;
  type: string;
}
